import React, { useEffect, useState, useCallback } from "react";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { Suport, ButtonOrder, InputForm, ButtonSearch } from "./styles";
import ListReportsTumorBoard from "./list";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Row,
  Col,
  FormGroup,
  InputGroup,
  Alert,
  Table,
  InputGroupAddon,
  InputGroupText,
  Input,
  PaginationLink,
  PaginationItem,
  Pagination,
  Spinner,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { deleteCookies } from "../../utils/functions";
import { validateDates } from "../../utils/validations";
import {
  faHistory,
  faHospitalUser,
  faSort,
  faMicroscope,
  faCalendarCheck,
  faSearch,
  faQuestionCircle,
  faCheckCircle,
  faEyeDropper,
  faMehRollingEyes,
  faEye,
} from "@fortawesome/free-solid-svg-icons";
import { useHistory, useLocation } from "react-router-dom";
import api from "../../services/client/api";
import cookie from "../../services/cookie/index";
import ActivateReports from "../../components/ActivateReports";
export default function ReportsTumorBoardView() {
  useEffect(() => {
    document.title = "CEDAP | Tumor Board Oncológico ";
  }, []);

  const [nestedModal, setNestedModal] = useState(false);
  const [selectedPaciente, setSelectedPaciente] = useState(null);
  const [pacientes, setPacientes] = useState([]);
  let [, setQtdPages] = useState(0);
  const [page, setPage] = useState(1);
  let [search, setSearch] = useState("");
  let [searchRegister, setSearchRegister] = useState("");
  const history = useHistory();
  const [manualPaciente, setManualPaciente] = useState(false);
  const location = useLocation();
  const [medicoSearch, setMedicoSearch] = useState("");
  const [medicoSelecionado, setMedicoSelecionado] = useState(null);
  const [filteredMedicos, setFilteredMedicos] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showActivateReports, setShowActivateReports] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [order, setOrder] = useState("desc");
  const token = cookie().get("tokenDoc");
  const getToday = () => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  };
  const [newHistoric, setNewHistoric] = useState({
    dataRegistro: getToday(),
    descricaoRegistro: "",
  });
  const [reports, setReports] = useState([]);
  const [inativeReports, setInativeReports] = useState([]);
  const [medicos, setMedicos] = useState([]);

  const username = cookie().get("username");

  const [isReportsNull, setReportsNull] = useState(false);
  const [isFilteredByDate, setIsFilteredByDate] = useState(false);

  const toggleNested = () => {
    setNestedModal(!nestedModal);
    setSearch("");
    setPacientes([]);
  };
  const [form, setForm] = useState({
    codRequisicao: "",
    nomePaciente: "",
    idade: "",
    nomeMedico: "",
    instituicao: "",
    dataReuniao: getToday(),
    descricao: "",
  });

  useEffect(() => {
    const checkSession = async () => {
      if (!token || !username) {
        await deleteCookies();
        alert("Sessão expirada, por favor, realize o login novamente!");
        history.replace("/login");
      }
    };

    // Checagem inicial
    checkSession();

    // Checagem periódica a cada 5 segundos
    const interval = setInterval(checkSession, 5000);

    // Limpa o intervalo quando o componente desmonta
    return () => clearInterval(interval);
  }, [token, username, history]);
  const [isLoading, setIsLoading] = useState(true);
  const qtdPerPage = 7; // exames por página
  const [modalOpen, setModalOpen] = useState(false);
  let [usersFound, setUsersFound] = useState([]);
  const dataToUse = search ? usersFound : reports;

  const groupedByPatient = Object.values(
    dataToUse.reduce((acc, report) => {
      if (!acc[report.CodTumorBoard]) {
        acc[report.CodTumorBoard] = [];
      }
      acc[report.CodTumorBoard].push(report);
      return acc;
    }, {}),
  );

  const fetchByWord = async (value) => {
    if (!value) return;

    try {
      const response = await api()
        .user()
        .getAllTumorBoardPatients(token, username, value);

      setPacientes(response.output || []);
    } catch (error) {
      console.error("Erro na busca:", error);
    }
  };

  const handleClearPaciente = () => {
    setSelectedPaciente(null);
    setManualPaciente(false);
    setSearch("");
    toggleNested(); // reabre busca
  };

  let timeout = null;

  const handleSelectPaciente = (paciente) => {
    setSelectedPaciente(paciente);

    // joga pro form
    setForm((prev) => ({
      ...prev,
      nomePaciente: paciente.NomPaciente,
      nomeMaePaciente: paciente.NomMae,
      dataNasc: paciente.DtaNascimento,
    }));

    setNestedModal(false);
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchRegister(value);

    clearTimeout(timeout);

    const trimmed = value.trim();

    // mínimo 3 caracteres
    if (trimmed.length < 3) return;

    timeout = setTimeout(() => {
      fetchByWord(trimmed);
    }, 400);
  };

  const registerTumorBoard = async () => {
    try {
      const payload = {
        NomPaciente: form.nomePaciente,
        CodPaciente: selectedPaciente?.CodPaciente || null,
        Idade: selectedPaciente
          ? calcularIdade(selectedPaciente.DtaNascimento)
          : form.idade
            ? Number(form.idade)
            : null,
        CodMedico: medicoSelecionado?.CodMedico || null,
        CodInstituicao: medicoSelecionado?.CodInstituicao || null,
        DtaReuniao: new Date(form.dataReuniao).toISOString(),
        DtaRegistro: new Date().toISOString() || null || "",
        Ativo: true,
        DataReg: newHistoric.dataRegistro
          ? new Date(newHistoric.dataRegistro).toISOString()
          : null,
        DesEvolucao: newHistoric.descricaoRegistro || null,
        username: username,
      };

      const response = await api().user().registerTumorBoard(token, payload);

      if (response.status === 201) {
        window.location.reload();
        return true;
      }
      if (response.status === 401) {
        await deleteCookies();
        history.replace({ pathname: "/login" });
        return;
      }

      return false;
    } catch (error) {
      console.error("Erro ao salvar:", error);
      return false;
    }
  };

  const sortedReports = [...reports].sort((a, b) => {
    const dateA = new Date(a.DtaReuniao);
    const dateB = new Date(b.DtaReuniao);
    return order === "desc" ? dateB - dateA : dateA - dateB;
  });

  const calcularIdade = (dataNascimento) => {
    if (!dataNascimento) return null;

    let nascimento;

    if (dataNascimento.includes("-") && dataNascimento.length === 10) {
      const [dia, mes, ano] = dataNascimento.split("-");
      nascimento = new Date(`${ano}-${mes}-${dia}`);
    } else {
      // ISO (1973-01-17T00:00:00Z)
      nascimento = new Date(dataNascimento);
    }

    if (isNaN(nascimento)) return null;

    const hoje = new Date();
    let idade = hoje.getFullYear() - nascimento.getFullYear();

    const mes = hoje.getMonth() - nascimento.getMonth();

    if (mes < 0 || (mes === 0 && hoje.getDate() < nascimento.getDate())) {
      idade--;
    }

    return idade;
  };

  useEffect(() => {
    if (search !== "") {
      let usersSearching = reports.filter(
        (report) =>
          report.NomPaciente?.toLowerCase().includes(
            search.toLowerCase(),
          ) /*  ||
            maskCPF(user.cpf).includes(search) ||
            user.cpf.includes(search) ||
            ns(user.email).includes(search) */,
      );

      setUsersFound(usersSearching);
      setQtdPages(Math.round(usersSearching.length / 15));
      setPage(1);
      return;
    }

    setPage(1);
    setQtdPages(Math.round(reports.length / 15));
    setUsersFound(reports);
  }, [search, setUsersFound, reports]);

  const toggleModal = () => {
    setModalOpen(!modalOpen);
    setSelectedPaciente(null);
    setManualPaciente(false);
  };

  // Atualiza qualquer campo
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({
      ...form,
      [name]: value,
    });
  };

  // Envio do formulário
  const handleSubmit = async () => {
    if (!token || !username) {
      await deleteCookies();
      alert("Sessão expirada, por favor, realize o login novamente!");
      history.replace({ pathname: "/login" });
      return;
    }

    if (!form.nomePaciente || !form.dataReuniao || !form.nomeMedico) {
      alert("Preencha os campos obrigatórios");
      return;
    }
    const success = await registerTumorBoard();

    if (!success) {
      alert("Erro ao salvar");
      return;
    }

    alert("Salvo com sucesso!");

    toggleModal();

    // limpar form
    setForm({
      codRequisicao: "",
      nomePaciente: "",
      idade: "",
      nomeMedico: "",
      instituicao: "",
      dataReuniao: getToday(),
      descricao: "",
    });

    setNewHistoric({
      dataRegistro: "",
      descricaoRegistro: "",
    });
  };

  const handleHistoricChange = (e) => {
    const { name, value } = e.target;
    setNewHistoric((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const paginatedReports = groupedByPatient.slice(
    qtdPerPage * (page - 1),
    qtdPerPage * page,
  );

  const qtdPages = Math.ceil(groupedByPatient.length / qtdPerPage);
  const getReports = useCallback(async () => {
    setReportsNull(false);
    try {
      const response = await api().user().getAllTumorBoard(token, username);

      if (response.status === 401) {
        await deleteCookies();
        history.replace({ pathname: "/login" });
        return;
      }

      if (response.status === 200) {
        setIsFilteredByDate(false);

        setMedicos(response.output.TumorBoardMedicos);
        setReports(
          response.output.TumorBoardCadastro.filter((report) => report.Ativo),
        );
        setInativeReports(
          response.output.TumorBoardCadastro.filter((report) => !report.Ativo),
        );
        setIsLoading(false);
      } else if (response.status === 404) {
        setReportsNull(true);
        setIsLoading(false); // muito importante
      } else if (response.status === 400) {
        setErrorMessage("error");
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Erro ao obter arquivos:", error);
      setErrorMessage("Erro ao carregar arquivos.");
      setIsLoading(false);
    }
  }, [history, token]);

  useEffect(() => {
    if (username) {
      getReports();
    }

    if (location.state?.successMessage) {
      alert(location.state.successMessage);
      history.replace({ pathname: location.pathname, state: {} });
    }
  }, [username, location, history, getReports]);

  const handleMedicoChange = (e) => {
    const value = e.target.value;
    setMedicoSearch(value);

    if (!value) {
      setFilteredMedicos([]);
      return;
    }

    const filtered = medicos.filter((m) =>
      m.NomMedico.toLowerCase().includes(value.toLowerCase()),
    );

    setFilteredMedicos(filtered);
    setShowDropdown(true);
  };

  const handleSelectMedico = (medico) => {
    setMedicoSelecionado(medico);
    setMedicoSearch(medico.NomMedico);
    setShowDropdown(false);

    // se quiser salvar no form também:
    setForm((prev) => ({
      ...prev,
      nomeMedico: medico.NomMedico,
      codMedico: medico.CodMedico,
    }));
  };

  const openActivateReports = (report) => {
    setShowActivateReports(true);
  };

  const handleCloseActivateReports = () => {
    setShowActivateReports(false);
  };

  const PaginationComponent = () => {
    let elements = [];

    for (let i = page - 3; i < page; i++) {
      if (i > 0) {
        elements.push(
          <PaginationItem key={i} active={i === page}>
            <PaginationLink onClick={() => setPage(i)}>{i}</PaginationLink>
          </PaginationItem>,
        );
      }
    }

    for (let i = page - 1; i < qtdPages && i < page + 3; i++) {
      const thisPage = i + 1;
      elements.push(
        <PaginationItem key={thisPage} active={thisPage === page}>
          <PaginationLink onClick={() => setPage(thisPage)}>
            {thisPage}
          </PaginationLink>
        </PaginationItem>,
      );
    }

    return (
      <Pagination>
        <PaginationItem>
          <PaginationLink
            first
            onClick={() => setPage(1)}
            disabled={page === 1}
          />
        </PaginationItem>

        <PaginationItem disabled={page === 1}>
          <PaginationLink previous onClick={() => setPage(page - 1)} />
        </PaginationItem>

        {elements}

        <PaginationItem disabled={page === qtdPages}>
          <PaginationLink next onClick={() => setPage(page + 1)} />
        </PaginationItem>

        <PaginationItem disabled={page === qtdPages}>
          <PaginationLink last onClick={() => setPage(qtdPages)} />
        </PaginationItem>
      </Pagination>
    );
  };

  return (
    <div>
      <h1>
        <FontAwesomeIcon icon={faMicroscope} /> Relatório de Exames
      </h1>

      <ButtonOrder color="secondary" onClick={toggleModal}>
        Registrar Reunião <FontAwesomeIcon icon={faHospitalUser} />
      </ButtonOrder>

      <Row
        style={{
          display: "flex",
          alignItems: "center",
          marginTop: "10px",
        }}
      >
        {/* Input ocupa a esquerda */}
        <Col md={6}>
          <FormGroup style={{ marginBottom: 0 }}>
            <InputGroup>
              <InputGroupAddon addonType="prepend">
                <InputGroupText>Buscar Por Nome</InputGroupText>
              </InputGroupAddon>

              <Input
                onChange={(e) => setSearch(e.target.value)}
                value={search}
                required
                type="text"
              />
            </InputGroup>
          </FormGroup>
        </Col>

        {/* Botão na direita */}
        <Col
          md={6}
          style={{
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <ButtonSearch
            color="secondary"
            onClick={() => openActivateReports(reports)}
          >
            Reativar Casos <FontAwesomeIcon icon={faEye} />
          </ButtonSearch>
        </Col>
      </Row>
      {showActivateReports && (
        <ActivateReports
          token={token}
          username={username}
          onClose={handleCloseActivateReports}
          reports={inativeReports}
        />
      )}
      <Modal isOpen={modalOpen} toggle={toggleModal} size="lg">
        <ModalHeader toggle={toggleModal}>
          Registrar Reunião realizada
        </ModalHeader>
        <ModalBody>
          <div
            style={{
              marginTop: "10px",
              marginBottom: "10px",
              marginLeft: "10px",
              fontWeight: "bold",
            }}
          >
            Informações do paciente <FontAwesomeIcon icon={faHospitalUser} />
          </div>

          {!selectedPaciente && !manualPaciente && (
            <ButtonSearch onClick={toggleNested}>
              Buscar paciente <FontAwesomeIcon icon={faSearch} />
            </ButtonSearch>
          )}

          {selectedPaciente && (
            <>
              <ButtonSearch onClick={handleClearPaciente}>
                Buscar outro paciente <FontAwesomeIcon icon={faSearch} />
              </ButtonSearch>
              <Row style={{ display: "flex", alignItems: "flex-end" }}>
                <Col md={6}>
                  <FormGroup>
                    <span className="label-form">Nome Paciente:</span>
                    <InputForm value={selectedPaciente.NomPaciente} disabled />
                  </FormGroup>
                </Col>

                <Col md={3}>
                  <FormGroup>
                    <span className="label-form">Data de nascimento:</span>
                    <InputForm
                      value={selectedPaciente?.DtaNascimento || ""}
                      disabled
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <span className="label-form">Nome da Mãe:</span>
                    <InputForm
                      value={selectedPaciente?.NomMae || ""}
                      disabled
                    />
                  </FormGroup>
                </Col>
              </Row>
            </>
          )}

          {manualPaciente && !selectedPaciente && (
            <>
              <ButtonSearch onClick={handleClearPaciente}>
                Buscar outro paciente <FontAwesomeIcon icon={faSearch} />
              </ButtonSearch>
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <span className="label-form">Nome do Paciente:</span>
                    <InputForm
                      value={form.nomePaciente}
                      name="nomePaciente"
                      onChange={handleChange}
                    />
                  </FormGroup>
                </Col>

                <Col md={3}>
                  <FormGroup>
                    <span className="label-form">Idade:</span>
                    <InputForm
                      type="number"
                      name="idade"
                      value={form.idade}
                      onChange={handleChange}
                    />
                  </FormGroup>
                </Col>
              </Row>
            </>
          )}

          <div
            style={{
              marginTop: "10px",
              marginBottom: "10px",
              marginLeft: "10px",
              fontWeight: "bold",
            }}
          >
            Informações da reunião <FontAwesomeIcon icon={faCalendarCheck} />
          </div>
          <Row>
            <Col md={6}>
              <FormGroup>
                <span className="label-form">Data da reunião:</span>
                <InputForm
                  type="date"
                  required
                  name="dataReuniao"
                  value={form.dataReuniao}
                  onChange={handleChange}
                />
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col md={8}>
              <FormGroup style={{ position: "relative" }}>
                <span className="label-form">Nome do médico:</span>

                <InputForm
                  type="text"
                  name="nomeMedico"
                  value={medicoSearch}
                  required
                  onChange={handleMedicoChange}
                  onFocus={() => setShowDropdown(true)}
                  autoComplete="off"
                />

                {showDropdown && filteredMedicos.length > 0 && (
                  <div
                    style={{
                      position: "absolute",
                      width: "100%",
                      background: "#fff",
                      border: "1px solid #ccc",
                      maxHeight: "200px",
                      overflowY: "auto",
                      zIndex: 10,
                    }}
                  >
                    {filteredMedicos.map((medico, index) => (
                      <div
                        key={index}
                        style={{
                          padding: "8px",
                          cursor: "pointer",
                        }}
                        onClick={() => handleSelectMedico(medico)}
                      >
                        {medico.NomMedico}
                      </div>
                    ))}
                  </div>
                )}
              </FormGroup>
            </Col>
          </Row>

          <div
            style={{
              marginTop: "10px",
              marginBottom: "10px",
              marginLeft: "10px",
              fontWeight: "bold",
            }}
          >
            Histórico <FontAwesomeIcon icon={faHistory} />
          </div>

          <div
            style={{
              padding: "10px",
              borderRadius: "5px",
            }}
          >
            <Table bordered responsive>
              <thead>
                <tr>
                  <th style={{ textAlign: "center" }}>Data</th>
                  <th>Descrição</th>
                </tr>
              </thead>
              <tbody>
                <tr style={{ backgroundColor: "#e8f4ff" }}>
                  <td style={{ width: "150px" }}>
                    <Input
                      type="date"
                      name="dataRegistro"
                      value={newHistoric.dataRegistro}
                      onChange={handleHistoricChange}
                    />
                  </td>

                  <td>
                    <div style={{ display: "flex", gap: "10px" }}>
                      <Input
                        type="text"
                        name="descricaoRegistro"
                        placeholder="Digite a evolução..."
                        value={newHistoric.descricaoRegistro}
                        onChange={handleHistoricChange}
                      />
                    </div>
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>

          <Modal isOpen={nestedModal} toggle={toggleNested} size="lg">
            <ModalHeader toggle={toggleNested}>
              Buscar paciente
              <Button
                color="dark"
                style={{ marginLeft: "280px", float: "right" }}
                onClick={() => {
                  setManualPaciente(true);
                  setSelectedPaciente(null);
                  setNestedModal(false); // ou toggleNested()
                }}
              >
                Não encontrei o paciente{" "}
                <FontAwesomeIcon icon={faQuestionCircle} />
              </Button>
            </ModalHeader>

            <ModalBody>
              <span className="label-form">Digite o nome do Paciente:</span>
              <Input
                placeholder="Digite o nome do paciente"
                value={searchRegister}
                onChange={handleSearchChange}
              />

              <Table striped className="mt-3">
                <thead>
                  <tr>
                    <th>Nome</th>
                    <th>Data de Nascimento</th>
                    <th>Nome da mãe</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {pacientes.map((p) => (
                    <tr key={p.CodPaciente}>
                      <td>{p.NomPaciente}</td>
                      <td>{p.DtaNascimento}</td>
                      <td>{p.NomMae}</td>
                      <td>
                        <Button
                          color="success"
                          size="sm"
                          onClick={() => handleSelectPaciente(p)}
                        >
                          Selecionar
                        </Button>
                      </td>
                      {pacientes.length === 0 && (
                        <tr>
                          <td colSpan="4" className="text-center">
                            Nenhum resultado
                          </td>
                        </tr>
                      )}
                    </tr>
                  ))}
                </tbody>
              </Table>
            </ModalBody>

            <ModalFooter>
              <Button color="secondary" onClick={toggleNested}>
                Fechar
              </Button>
            </ModalFooter>
          </Modal>
        </ModalBody>

        <ModalFooter>
          <Button color="primary" onClick={handleSubmit}>
            Salvar
          </Button>
        </ModalFooter>
      </Modal>
      {isReportsNull ? (
        <Alert color="warning">
          Nenhum exame encontrado nas datas selecionadas.
        </Alert>
      ) : (
        <Table striped bordered responsive style={{ marginTop: "10px" }}>
          <thead>
            <tr>
              <th style={{ textAlign: "center" }}> </th>
              <th style={{ textAlign: "center" }}>Reunião</th>
              <th style={{ textAlign: "center" }}>Nome Paciente</th>
              <th
                style={{
                  textAlign: "center",
                  cursor: "pointer",
                  userSelect: "none",
                }}
                onClick={() => setOrder(order === "desc" ? "asc" : "desc")}
              >
                Data Reunião{" "}
                <FontAwesomeIcon
                  icon={order === "desc" ? faSort : faSort}
                  style={{
                    marginLeft: 3,
                    fontSize: "1.0rem",
                    opacity: 0.7,
                  }}
                />
              </th>
              <th style={{ textAlign: "center" }}>Médico</th>
              <th style={{ textAlign: "center" }}>Instituição</th>
              <th style={{ textAlign: "center" }}>Laudo</th>
              <th style={{ textAlign: "center" }}>Visualização</th>
            </tr>
          </thead>

          <tbody>
            {paginatedReports.map((patientReports, index) => (
              <ListReportsTumorBoard
                key={index}
                reports={patientReports}
                medicos={medicos}
                token={token}
                username={username}
              />
            ))}
          </tbody>
        </Table>
      )}
      {qtdPages > 1 && <PaginationComponent />}

      <Suport href="https://wa.me/5547991865855" target="_blank">
        <u>Suporte</u>
        <FontAwesomeIcon icon={faWhatsapp} color="#25d366" />
      </Suport>
    </div>
  );
}
